import type { ADFEntity } from '@atlaskit/adf-utils/types';
import type { BlocksSnippetAri } from '@atlassian/ari';

export enum SnippetProduct {
	// Only Confluence is allowed currently but more will be added:
	// 		https://bitbucket.org/atlassian/block-service/src/main/nebulae/seeding/ers/schemas
	CONFLUENCE = 'CONFLUENCE',
}

export enum SnippetContentFormat {
	// Only ADF is allowed currently but more will be added:
	// 		https://bitbucket.org/atlassian/block-service/src/main/nebulae/seeding/ers/schemas
	ADF = 'ADF',
}

export type SnippetOwner =
	| {
			accountId: string;
			displayName: string;
	  }
	| {
			accountId: 'atlassian';
			displayName?: 'Atlassian';
	  };

export type Snippet = {
	ari: BlocksSnippetAri;
	snippetId: string; // uuidv7
	name: string;
	description?: string;
	contentFormat: SnippetContentFormat;
	content?: ADFEntity | ADFEntity[];
	product: SnippetProduct;
	label?: string;
	isFavorite: boolean;
	createdBy: SnippetOwner;
	createdAt: Date;
	updatedAt?: Date;
};
